const faqs: { title: string; content: string }[] = [
  {
    title: 'faq-question_1',
    content: 'faq-answer_1',
  },
  {
    title: 'faq-question_2',
    content: 'faq-answer_2',
  },
  {
    title: 'faq-question_3',
    content: 'faq-answer_3',
  },
  {
    title: 'faq-question_4',
    content: 'faq-answer_4',
  },
  {
    title: 'faq-question_5',
    content: 'faq-answer_5',
  },
  {
    title: 'faq-question_6',
    content: 'faq-answer_6',
  },
  {
    title: 'faq-question_7',
    content: 'faq-answer_7',
  },
  {
    title: 'faq-question_8',
    content: 'faq-answer_8',
  },
];

export default faqs;
